// extracted by mini-css-extract-plugin
export default {"container":"zKd0W","redirectBtn":"_3mGRU"};